import React from "react";
import MainInput from "../../Elements/MainInput/MainInput";
import searchIcon from "../../../assets/icons/data/search.png";
import "./FAQSearchInput.css";

const FAQSearchInput = ({ value, onChange, placeholder }) => {
  return (
    <div className="faq-search-wrapper">
      <img src={searchIcon} alt="Search FAQ" className="faq-search-icon" />
      <MainInput value={value} onChange={onChange} placeholder={placeholder} />
    </div>
  );
};

export default FAQSearchInput;
